import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './components/RGD_files/img.png'


const _hoisted_1 = {
  class: "all",
  style: {"margin-bottom":"0px"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = {
  class: "container",
  id: "RGDFoot",
  style: {"background":"bottom"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", { style: {"background-color":"#0c64b6","height":"2px","border":"0px","margin-top":"0px","margin-bottom":"0px"} }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "bigd-panel bigd-panel-default" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bigd-panel-body" }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "text-center",
      style: {"margin":"0px 0 6px"}
    }, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://www.csu.edu.cn//",
        target: "_blank"
      }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_0,
          style: {"width":"50px"}
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("p", {
      class: "text-center",
      style: {"color":"black"}
    }, [
      /*#__PURE__*/_createTextVNode("Copyright ©  Central South University All Rights Reserved"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" This site is designed to work with IE 9 and above, Firefox, Chrome, Safari and Opera. If you need some help, feel free to "),
      /*#__PURE__*/_createElementVNode("a", { href: "mailto:weiweifu666@126.com" }, "contact us"),
      /*#__PURE__*/_createTextVNode(". ")
    ]),
    /*#__PURE__*/_createElementVNode("hr", {
      class: "footer-hr",
      style: {"margin-top":"0"}
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("nav", null, [
          _createVNode(_component_a_layout_header, { style: {"background-color":"#00c0ef","position":"absolute","right":"0","top":"0"} }, {
            default: _withCtx(() => [
              _createVNode(_component_a_menu, {
                mode: "horizontal",
                modelValue: _ctx.selectedKey,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedKey) = $event)),
                style: {"background-color":"#2CAADC","position":"absolute","right":"0","top":"0"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_menu_item, {
                    key: "1",
                    onClick: _ctx.showWelcome,
                    style: {"color":"aliceblue","font-weight":"bold"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Home")
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_a_menu_item, {
                    key: "2",
                    onClick: _ctx.changeBrowsePage,
                    style: {"color":"aliceblue","font-weight":"bold"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Browse")
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_a_menu_item, {
                    key: "3",
                    onClick: _ctx.changeQueryPage,
                    style: {"color":"aliceblue","font-weight":"bold"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Query")
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_a_menu_item, {
                    key: "4",
                    onClick: _ctx.changeHelpPage,
                    style: {"color":"aliceblue","font-weight":"bold"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("HELP")
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_a_menu_item, {
                    key: "5",
                    onClick: _ctx.changeDownLoad,
                    style: {"color":"aliceblue","font-weight":"bold"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("DownLoad")
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_a_menu_item, {
                    key: "6",
                    onClick: _ctx.changeFeedBack,
                    style: {"color":"aliceblue","font-weight":"bold"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("FEEDBACK")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_a_card, { style: {"margin-top":"7px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_router_view, {
              "onUpdate:selectedKey": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedKey = $event))
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("footer", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_a_card, { style: {"margin-top":"0px"} }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ])
    ])
  ]))
}